var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H13M20.989 10C21 10.577 21 11.2365 21 12C21 14.8003 21 16.2004 20.455 17.27C19.9757 18.2108 19.2108 18.9757 18.27 19.455C17.2004 20 15.8003 20 13 20H11C8.19974 20 6.79961 20 5.73005 19.455C4.78924 18.9757 4.02433 18.2108 3.54497 17.27C3 16.2004 3 14.8003 3 12C3 11.2365 3 10.577 3.01105 10M20.989 10C20.9595 8.46078 20.8514 7.50797 20.455 6.73005C19.9757 5.78924 19.2108 5.02433 18.27 4.54497C17.2004 4 15.8003 4 13 4H11C8.19974 4 6.79961 4 5.73005 4.54497C4.78924 5.02433 4.02433 5.78924 3.54497 6.73005C3.14859 7.50797 3.04052 8.46078 3.01105 10M20.989 10H3.01105",
    stroke: "#FFFFFC",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/Card 1.43a09f6b746551c207cba9a7cdf34c06.svg";
export { ForwardRef as ReactComponent };